import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
import { SlingoConstants } from "../enum/SlingoConstants";
import { GameConfigData } from "./GameConfigData";
import { InstructionsConfigData } from "./InstructionsConfigData";
import { PayoutConfigData } from "./PayoutConfigData";
import { PrizeConfigData } from "./PrizeConfigData";
import { StakeConfigData } from "./StakeConfigData";
import { SymbolConfigData } from "./SymbolConfigData";
/**
 * ConfigData.ts
 */
export class ConfigData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.solidifyGameConfig();
            this.solidifyStakeConfig();
            this.solidifySymbolConfig();
            this.solidifyPayoutConfig();
            this.solidifyInstructionConfig();
            this.solidifyPrizeConfig(); //
        }
    }
    solidifyGameConfig() {
        let gameConfig = this.data.getDataObject(SlingoConstants.PROPERTY_GAME_CONFIG);
        if (this.dataExists(gameConfig)) {
            this.gameConfig = new GameConfigData(gameConfig);
        }
    }
    solidifyStakeConfig() {
        let stakeConfig = this.data.getDataObject(SlingoConstants.PROPERTY_STAKE_CONFIG);
        if (this.dataExists(stakeConfig)) {
            this.stakeConfig = new StakeConfigData(stakeConfig);
        }
    }
    solidifySymbolConfig() {
        let symbolConfig = this.data.getDataArray(SlingoConstants.PROPERTY_SYMBOL_CONFIG);
        if (this.dataExists(symbolConfig)) {
            this.symbolConfig = new SymbolConfigData(this.data);
        }
    }
    solidifyPayoutConfig() {
        let payoutConfig = this.data.getDataObject(SlingoConstants.PROPERTY_PAYOUT_CONFIG);
        if (this.dataExists(payoutConfig)) {
            this.payoutConfig = new PayoutConfigData(payoutConfig);
        }
    }
    solidifyInstructionConfig() {
        this.instructionsConfig = new InstructionsConfigData();
    }
    solidifyPrizeConfig() {
        this.prizeConfig = [];
        let prizeConfigs = this.data.getDataArray(SlingoConstants.PROPERTY_PRIZE_CONFIG);
        if (this.dataExists(prizeConfigs)) {
            for (let i = 0; i < prizeConfigs.length; i++) {
                let configData = new PrizeConfigData(prizeConfigs[i]);
                this.prizeConfig.push(configData);
            }
        }
    }
    getGameConfig() {
        return this.gameConfig;
    }
    getStakeConfig() {
        return this.stakeConfig;
    }
    getSymbolConfig() {
        return this.symbolConfig;
    }
    getPayoutConfig() {
        return this.payoutConfig;
    }
    getInstructionsConfig() {
        return this.instructionsConfig;
    }
    getPrizeConfig() {
        return this.prizeConfig.slice();
    }
}
//# sourceMappingURL=ConfigData.js.map